module.exports = __webpack_public_path__ + "img/logo-mobile.1042f0dd.svg";